/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Done_DescriptionInputs */

const es_walkthrough_done_description = /** @type {(inputs: Walkthrough_Done_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eso es lo esencial. Explorá a tu ritmo — Nexy está listo cuando vos lo estés.`)
};

const en_walkthrough_done_description = /** @type {(inputs: Walkthrough_Done_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That's the essentials. Explore at your pace — Nexy is ready whenever you are.`)
};

/**
* | output |
* | --- |
* | "That's the essentials. Explore at your pace — Nexy is ready whenever you are." |
*
* @param {Walkthrough_Done_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_done_description = /** @type {((inputs?: Walkthrough_Done_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Done_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_done_description(inputs)
	return en_walkthrough_done_description(inputs)
});
export { walkthrough_done_description as "walkthrough.done_description" }